function onYouTubeIframeAPIReady() {
    HomeVideoPopin.start();
}
var HomeVideoPopin = (function () {

    var template, player, url, lang;

    var init = function () {

            var alreadySeen = false,
                tpl = $('#home-video-popin-tpl');
            lang = $('html').attr('lang');
            if (window.sessionStorage) {
                alreadySeen = window.sessionStorage.getItem(lang+'HomePopin') === 'true';
            }

            if (!tpl.length || alreadySeen) return;
            template = _.template(tpl.html());
            $('body').append(template())
            url = $('.video-popin').attr('data-url');
            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        },
        onPlayerReady = function (event) {
            event.target.playVideo()
        },
        onPlayerStateChange = function (event) {
            if (event.data === 0) {
                close();
            }
        },
        close = function () {
            player.pauseVideo();
            $('.video-popin').addClass('closed');
            if (window.sessionStorage) {
                window.sessionStorage.setItem(lang+'HomePopin', true);
            }
            setTimeout(function () {
                player.stopVideo();
                $('.video-popin').remove()
            }, 750)
        },
        start = function () {
            player = new YT.Player('video-popin-player', {
                playerVars: { 'autoplay': 1, 'controls': 0, 'modestbranding': 1, 'rel': 0 },
                videoId: url,
                events: {
                    'onReady': onPlayerReady,
                    'onStateChange': onPlayerStateChange
                }
            });
            $('.video-popin').find('.button').on('click', close)
         };


    return {
        init: init,
        start: start
    };

})();